/**
 * @overview 场地预约管理
 * @author jzhu
 * @date 2020-8-14
 */

import React from 'react'
import { connect } from 'dva'
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool } from '../../../tool'
let { WizContainer, WizReduxTemplate, modelUtils } = framework_tool

class SiteOrderManager extends WizContainer {

    componentName = 'SiteOrderManager'

    constructor(props) {
        super(props)
        this.state = {
        }
    }

    _componentDidMount() {
        this.doAction({
            path: 'trainCenter/info',
            payload: {
                key: 'trainCenter_info',
                apiParams: {
                    type: 'FOLDER'
                }
            }
        })
    }

    propsAndStateOnChange = {
        trainCenterList: this._getTrainCenterOver.bind(this)
    }

    _getTrainCenterOver(nextProps, nextState) {
        let _list = []
        if (nextProps.trainCenterList.code === 1) {
            let list = nextProps.trainCenterList.data
            list && list.forEach(val => {
                _list.push({ code: val['id'], codeName: val['name'] })
            })
            nextState.trainCenterList = _list
            return true
        } else {
            wizNotice.error(nextProps.trainCenterList.msg)
            return false
        }
    }

    _render() {
        let trainCenterList = {}
        if (this.state && this.state.trainCenterList && this.state.trainCenterList.length) {
            trainCenterList = this.state.trainCenterList
        }
        let _reduxTemplateCofig = reduxTemplateCofig({
            templateConfig: templateConfig(trainCenterList),
            apiDataFormat: {}
        })
        return <WizReduxTemplate {..._reduxTemplateCofig} />
    }
}

const mapStateToProps = (state, ownProps) => {
    const { trainCenter } = state
    const trainCenterList = modelUtils.getModelEntity(trainCenter, 'trainCenter_info')
    const load = modelUtils.getLoadingState(state, ['trainSite', 'trainCenter'])
    return {
        trainCenterList: trainCenterList,
        ...load
    }
}

export default connect(mapStateToProps)(SiteOrderManager)
